import { action, makeObservable } from 'mobx'
import { BaseFieldStore } from './BaseFieldStore'
import { IFieldDefinition } from './Types/FieldTypeEnum'

/**
 * Поле для массивов примитивных значений
 */
export class ArrayFieldStore extends BaseFieldStore {
    constructor(definition: IFieldDefinition, formContext: any, path: string[] = []) {
        super(definition, formContext, path)

        makeObservable(this, {
            add: action,
            remove: action,
            moveItem: action,
        })

        // Ініціалізуємо масивом з одним порожнім елементом якщо значення undefined
        const currentValue = this.value
        if (currentValue === undefined || currentValue === null) {
            this.setValue([''])
        } else if (Array.isArray(currentValue) && currentValue.length === 0) {
            // Якщо масив порожній, додаємо один порожній елемент
            this.setValue([''])
        }
    }

    /**
     * Добавить элемент в массив
     */
    add(value: any = ''): void {
        const currentValue = this.value || []
        const newValue = [...currentValue, value]
        this.setValue(newValue)
    }

    /**
     * Удалить элемент по индексу
     */
    remove(index: number): void {
        const currentValue = this.value || []
        if (index >= 0 && index < currentValue.length) {
            const newValue = currentValue.filter((_: any, i: number) => i !== index)
            this.setValue(newValue)
        }
    }

    /**
     * Переместить элемент
     */
    moveItem(fromIndex: number, toIndex: number): void {
        const currentValue = this.value || []
        if (
            fromIndex >= 0 &&
            fromIndex < currentValue.length &&
            toIndex >= 0 &&
            toIndex < currentValue.length
        ) {
            const newValue = [...currentValue]
            const item = newValue.splice(fromIndex, 1)[0]
            newValue.splice(toIndex, 0, item)
            this.setValue(newValue)
        }
    }

    /**
     * Получить элемент по индексу
     */
    getItem(index: number): any {
        const currentValue = this.value || []
        return currentValue[index]
    }

    /**
     * Установить элемент по индексу
     */
    setItem(index: number, value: any): void {
        const currentValue = this.value || []
        if (index >= 0 && index < currentValue.length) {
            const newValue = [...currentValue]
            newValue[index] = value
            this.setValue(newValue)
        }
    }

    get length(): number {
        const currentValue = this.value || []
        return currentValue.length
    }
}
